import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import '../styling/TechStack.css';

function TechStack() {
  const [activeCategory, setActiveCategory] = useState('all');

  const techStackData = {
    mobile: {
      label: "Mobile Development",
      icon: "📱",
      skills: ["React Native", "Expo", "JavaScript", "TypeScript"]
    },
    frontend: {
      label: "Frontend",
      icon: "🎨",
      skills: ["React", "Next.js", "Tailwind CSS", "HTML5", "CSS3"]
    },
    backend: {
      label: "Backend",
      icon: "⚙️",
      skills: ["Python", "Django", "Django REST Framework"]
    },
    database: {
      label: "Database",
      icon: "🗄️",
      skills: ["MySQL", "PostgreSQL", "SQLite", "Firebase Firestore"]
    },
    infrastructure: {
      label: "Infrastructure",
      icon: "🏗️",
      skills: ["Google Cloud", "AWS", "VPS", "Gunicorn", "Nginx"]
    },
    fintech: {
      label: "Fintech Expertise",
      icon: "💳",
      skills: ["Wallet Systems", "Virtual Accounts", "Cards", "Webhooks", "Reconciliation", "KYC Verification"]
    },
    integrations: {
      label: "Payment Integrations",
      icon: "🔗",
      skills: ["Flutterwave", "Stripe", "Google Pay", "Apple Pay", "Paystack", "RevenueCat"]
    },
    monitoring: {
      label: "Monitoring & Analytics",
      icon: "📊",
      skills: ["Firebase Analytics", "Mixpanel", "PostHog", "Sentry"]
    },
    tools: {
      label: "Tools & DevOps",
      icon: "🛠️",
      skills: ["Git", "GitHub", "Postman", "Figma"]
    }
  };

  // Logo carousel data
  const logos = [
    { name: "React", path: "/images/react.png", alt: "React/React Native" },
    { name: "Expo", path: "/images/expo.svg", alt: "Expo" },
    { name: "Python", path: "/images/python.png", alt: "Python" },
    { name: "Django", path: "/images/django.png", alt: "Django" },
    { name: "Next.js", path: "/images/nextjs.png", alt: "Next.js" },
    { name: "Firebase", path: "/images/firebase.png", alt: "Firebase" },
    { name: "Supabase", path: "/images/supabase.png", alt: "Supabase" },
    { name: "JavaScript", path: "/images/JavaScript.png", alt: "Javascript" },
    { name: "TypeScript", path: "/images/typescript.svg", alt: "TypeScript" },
    { name: "AWS", path: "/images/Aws.png", alt: "AWS" },
    { name: "HTML", path: "/images/html.png", alt: "HTML" },
    { name: "CSS", path: "/images/css.png", alt: "CSS" },
    { name: "Bootstrap", path: "/images/BootstrapImage.png", alt: "Bootstrap" },
    { name: "Tailwind", path: "/images/tailwind.png", alt: "Tailwind" },
    { name: "Redux", path: "/images/redux.png", alt: "Redux" },
    { name: "PostgreSQL", path: "/images/postgres.png", alt: "PostgreSQL" },
    { name: "mySQL", path: "/images/mysql.png", alt: "mySQL" },
  ];

  const categories = Object.keys(techStackData);

  const getAllSkills = () => {
    return Object.values(techStackData).flatMap(cat => 
      cat.skills.map(skill => ({ skill, category: cat.label, categoryKey: Object.keys(techStackData).find(k => techStackData[k].label === cat.label) }))
    );
  };

  const getDisplaySkills = () => {
    if (activeCategory === 'all') {
      return getAllSkills();
    }
    return techStackData[activeCategory].skills.map(skill => ({ 
      skill, 
      category: techStackData[activeCategory].label,
      categoryKey: activeCategory
    }));
  };

  const displaySkills = getDisplaySkills();

  return (
    <section className="techstack-section">
      <Container className="techstack-container">
        {/* Header */}
        <div className="techstack-header">
          <span className="section-accent">Tech Stack</span>
          <h2 className="section-title">
            Skills & <span className="title-highlight">Technologies</span>
          </h2>
          <p className="section-subtitle">
            Specialized expertise in building scalable fintech systems with modern tech stacks
          </p>
          <div className="title-underline"></div>
        </div>

        {/* Logo Carousel */}
        <div className="logo-carousel-wrapper">
          <div className="logo-carousel">
            {[...logos, ...logos].map((logo, index) => (
              <div key={index} className="logo-item">
                <img 
                  src={logo.path} 
                  alt={logo.alt} 
                  title={logo.name}
                  className="logo-image"
                />
              </div>
            ))}
          </div>
          <div className="carousel-fade-left"></div>
          <div className="carousel-fade-right"></div>
        </div>

        {/* Category Filter */}
        <div className="category-filter">
          <button 
            className={`category-btn ${activeCategory === 'all' ? 'active' : ''}`}
            onClick={() => setActiveCategory('all')}
          >
            <span className="btn-text">All Skills</span>
          </button>
          {categories.map((cat) => (
            <button
              key={cat}
              className={`category-btn ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat)}
              title={techStackData[cat].label}
            >
              <span className="btn-icon">{techStackData[cat].icon}</span>
              <span className="btn-text">{techStackData[cat].label}</span>
            </button>
          ))}
        </div>

        {/* Skills Tags Cloud */}
        <div className="skills-cloud">
          {displaySkills.map((item, index) => (
            <div key={index} className="skill-tag">
              <span className="tag-text">{item.skill}</span>
              <span className="tag-category">{item.category}</span>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="techstack-stats">
          <div className="stat-item">
            <div className="stat-number">{Object.keys(techStackData).length}</div>
            <div className="stat-label">Categories</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">{getAllSkills().length}+</div>
            <div className="stat-label">Technologies</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">100%</div>
            <div className="stat-label">Production Ready</div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default TechStack;